<template>
  <div>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="content">
        <div class="columns">

          <div class="column is-9">
            <nav class="level mt-01">
              <p class="level-item has-text-centered">
                <router-link to="/" class="link is-info has-text-white">Inicio</router-link>
              </p>
              <p class="level-item has-text-centered">
                <router-link :to="{name:'Programas'}" class="link is-info has-text-white">Programas</router-link>
              </p>
              <p class="level-item has-text-centered">
                <router-link :to="{name:'Videos'}" class="link is-info has-text-white">Videos</router-link>
              </p>
              <p class="level-item has-text-centered">
                <router-link :to="{name:'Noticias'}" class="link is-info has-text-white">Noticias</router-link>
              </p>
              <p class="level-item has-text-centered">
                <router-link :to="{name:'RedesSociales'}" class="link is-info has-text-white">Redes Sociales</router-link>
              </p>
              <p class="level-item has-text-centered">
                <router-link :to="{name:'Contacto'}" class="link is-info has-text-white">Contacto</router-link>
              </p>
            </nav>
          </div>
          <div class="column is-3">
            <a href="https://twitter.com/MarioMachucaS" target="_blank" title="twitter"><img :src="twitterimg" alt="Twitter"/></a>
            <a href="https://www.facebook.com/mariomachuca.croc" target="_blank" title="facebook"><img :src="facebookimg" alt="Facebook"/></a>
            <a href="https://www.instagram.com/machucacroc/" target="_blank" title="instagram"><img :src="instagramimg" alt="Instagram" /></a>
          </div>
        </div>
        <p class="has-text-centered">Derechos reservados. Mario Machuca © 2016</p>
      </div>
    </footer>
  </div>
</template>

<script>
import facebook from '@/assets/img/facebook.png'
import twitter from '@/assets/img/twitter.png'
import instagram from '@/assets/img/instagram.png'

export default {
  data () {
    return {
      facebookimg:facebook,
      twitterimg:twitter,
      instagramimg:instagram,
    }
  },
  methods:{
  },
  created :function(){
  }
}
</script>

<style>
li{
  list-style: none;
}
.mt-05{
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue